// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `page-generic-container .page-generic-container__skeleton {
  padding: 8px 0 16px;
}
page-generic-container .page-generic-container__skeleton-item {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/generic-container/generic-container.scss"],"names":[],"mappings":"AACE;EACE,mBAAA;AAAJ;AAGE;EACE,cAAA;AADJ","sourcesContent":["page-generic-container {\n  .page-generic-container__skeleton {\n    padding: 8px 0 16px;\n  }\n\n  .page-generic-container__skeleton-item {\n    display: block;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
